export default {
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    sweetClose (args) {
      this.isOpen = false
      setTimeout(() => { this.$close(args) }, 300)
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
      let first = this.$el.querySelector('button, [tabindex], input')
      if (first) { first.focus() }
      document.activeElement.blur()
    }, 10)
  }
}
